module.exports = __webpack_public_path__ + "js/0.6f907a90.worker.js"